// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.transfer-of-mgt__head {
  display: flex;
}
.transfer-of-mgt__head__nav {
  font-weight: 500;
  color: #868686;
}
.transfer-of-mgt__head__nav-span {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #c1c1c1;
  padding-left: 10px;
  padding-right: 10px;
}
.transfer-of-mgt__head__heading {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
}
.transfer-of-mgt__head__top {
  display: flex;
}
.transfer-of-mgt__head__buttons {
  flex: 1 1;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-direction: column;
  margin-left: auto;
}
.transfer-of-mgt__head__buttons__Area {
  display: flex;
}
.transfer-of-mgt__head__buttons__Area__stat {
  padding-right: 10px;
}
.transfer-of-mgt__head__description {
  margin-top: 20px;
}
.transfer-of-mgt__head__description__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  color: #505054;
}
.transfer-of-mgt__head__description__content {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}
.transfer-of-mgt__head__calendar {
  width: 210px;
}
.transfer-of-mgt__body {
  display: flex;
  margin-top: 30px;
}
.transfer-of-mgt__body__col1 {
  width: 35%;
  height: 80vh;
  margin-right: 5px;
  background: #ffffff;
  border-radius: 16px;
  padding: 2%;
}
.transfer-of-mgt__body__col2 {
  width: 65%;
  margin-left: 5px;
  background: #ffffff;
  border-radius: 16px;
  padding: 2%;
}
.transfer-of-mgt__body__head {
  display: flex;
  margin-bottom: 20px;
}
.transfer-of-mgt__body__head__text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 32px;
  color: #333333;
}
.transfer-of-mgt__body__head__text-span {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 32px;
  color: #49ae9e;
}
.transfer-of-mgt__body__head__button {
  margin-left: auto;
}
.transfer-of-mgt__emp-table {
  max-height: 50vh;
  text-align: center;
  border-collapse: collapse;
  width: 100%;
  border-style: hidden;
}
.transfer-of-mgt__emp-table tbody {
  overflow-y: auto;
}
.transfer-of-mgt__emp-table__tr {
  height: 50px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 32px;
  cursor: pointer;
}
.transfer-of-mgt__emp-table__td {
  border: 1px solid #e9e9e9;
  text-align: center;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.transfer-of-mgt__emp-table .emp-table-item {
  position: relative;
}
.transfer-of-mgt__emp-table .emp-table-item:hover:not(.selected) ::after {
  content: "급여보기";
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 12px;
  font-weight: 400;
  align-items: center;
  justify-content: center;
  background-color: #fafafa;
}
.transfer-of-mgt__emp-table__td-content {
  border-bottom: 1px solid #e9e9e9;
  border-top: 1px solid #868686;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  color: #505054;
}
.transfer-of-mgt__emp-table__td-content-bold {
  border-bottom: 1px solid #e9e9e9;
  border-top: 1px solid #868686;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  color: #505054;
}
.transfer-of-mgt__emp-table__td-content-lite {
  position: relative;
  border-bottom: 1px solid #e9e9e9;
  border-top: 1px solid #868686;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  align-items: center;
  color: #505054;
}
.transfer-of-mgt__emp-table__td-content-lite:hover::after {
  content: "발송내역보기";
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  align-items: center;
  justify-content: center;
  background-color: #fafafa;
}
.transfer-of-mgt__emp-table__td-content-num {
  border-bottom: 1px solid #e9e9e9;
  border-top: 1px solid #868686;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  color: #505054;
}
.transfer-of-mgt__payroll-stmnt__description {
  margin-top: 10px;
  margin-bottom: 20px;
}
.transfer-of-mgt__payroll-stmnt__buttons {
  display: flex;
  flex-wrap: wrap;
}
.transfer-of-mgt__payroll-stmnt__button {
  margin-right: 5px;
  margin-bottom: 10px;
}
.transfer-of-mgt__payroll-stmnt__button-float {
  margin-right: 5px;
  margin-left: auto;
}
.transfer-of-mgt__payroll-stmnt__salary-type {
  margin-top: 20px;
  display: flex;
  align-items: center;
}
.transfer-of-mgt__payroll-stmnt__toggle__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
  margin-left: 10px;
}
.transfer-of-mgt__payroll-stmnt__toggle__subhead {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
  margin-left: 10px;
}
.transfer-of-mgt__payroll-stmnt__toggle__select {
  margin-left: auto;
}
.transfer-of-mgt__payroll-stmnt__toggle__dropdown {
  height: 40px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px 8px 8px 8px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
}
.transfer-of-mgt__payroll-stmnt__table {
  margin-top: 20px;
  text-align: center;
  border-collapse: collapse;
  width: 100%;
  border-radius: 6px;
  border-style: hidden;
  box-shadow: 0 0 0 1px #e9e9e9;
}
.transfer-of-mgt__payroll-stmnt__table__tr {
  height: 50px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 32px;
  cursor: pointer;
}
.transfer-of-mgt__payroll-stmnt__table__td {
  border: 1px solid #e9e9e9;
  border-top: 1px solid #868686;
  text-align: center;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
  background: #f9fafb;
}
.transfer-of-mgt__payroll-stmnt__table__td-content {
  border: 1px solid #e9e9e9;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.transfer-of-mgt__payroll-stmnt__table__td-content-bold {
  border: 1px solid #e9e9e9;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  color: #505054;
}
.transfer-of-mgt__payroll-stmnt__table__td-summary {
  border: 1px solid #e9e9e9;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  color: #505054;
  background: #f0f8f6;
}
.transfer-of-mgt__payroll-stmnt__table__td-summary-value {
  border: 1px solid #e9e9e9;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  text-align: right;
  color: #075453;
  text-align: end;
  padding-right: 25px;
  color: #505054;
  background: #f0f8f6;
}
.transfer-of-mgt__payroll-stmnt__table__input-row {
  display: flex;
  align-items: center;
  padding: 10px;
}
.transfer-of-mgt__payroll-stmnt__table__col-left {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
}
.transfer-of-mgt__payroll-stmnt__table__col-right {
  width: 90px;
  margin-left: auto;
}
.transfer-of-mgt__payroll-stmnt__table__amount {
  padding: 10px;
  width: 200px;
  margin: auto;
}`, "",{"version":3,"sources":["webpack://./src/screens/salary_specification/transfer-of-mgt/transfer-of-mgt.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEZ;EAEI,aAAA;AADR;AAGQ;EACI,gBAAA;EACA,cAAA;AADZ;AAIQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAFZ;AAKQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAHZ;AAMQ;EACI,aAAA;AAJZ;AAOQ;EACI,SAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,sBAAA;EACA,iBAAA;AALZ;AAOY;EACI,aAAA;AALhB;AAOgB;EACI,mBAAA;AALpB;AAUQ;EACI,gBAAA;AARZ;AAUY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AARhB;AAWY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAThB;AAaQ;EACI,YAAA;AAXZ;AAeI;EACI,aAAA;EACA,gBAAA;AAbR;AAeQ;EACI,UAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AAbZ;AAgBQ;EACI,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AAdZ;AAiBQ;EACI,aAAA;EACA,mBAAA;AAfZ;AAiBY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAfhB;AAkBY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAhBhB;AAmBY;EACI,iBAAA;AAjBhB;AAsBI;EACI,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,oBAAA;AApBR;AAsBQ;EACI,gBAAA;AApBZ;AAuBQ;EACI,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AArBZ;AAwBQ;EACI,yBAAA;EACA,kBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAvBZ;AA0BQ;EACI,kBAAA;AAxBZ;AA0BgB;EAEI,eAAA;EACA,aAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AAzBpB;AA8BQ;EACI,gCAAA;EACA,6BAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AA7BZ;AAgCQ;EACI,gCAAA;EACA,6BAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AA/BZ;AAkCQ;EACI,kBAAA;EACA,gCAAA;EACA,6BAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAjCZ;AAmCgB;EACI,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AAjCpB;AAsCQ;EACI,gCAAA;EACA,6BAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AArCZ;AA0CQ;EACI,gBAAA;EACA,mBAAA;AAxCZ;AA2CQ;EACI,aAAA;EACA,eAAA;AAzCZ;AA4CQ;EACI,iBAAA;EACA,mBAAA;AA1CZ;AA6CQ;EACI,iBAAA;EACA,iBAAA;AA3CZ;AA8CQ;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;AA5CZ;AAgDY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AA9ChB;AAiDY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AA/ChB;AAkDY;EACI,iBAAA;AAhDhB;AAmDY;EACI,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAlDhB;AAsDQ;EACI,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,6BAAA;AApDZ;AAsDY;EACI,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AApDhB;AAuDY;EACI,yBAAA;EACA,6BAAA;EACA,kBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAtDhB;AAyDY;EACI,yBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAvDhB;AA0DY;EACI,yBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAxDhB;AA2DY;EACI,yBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AAzDhB;AA4DY;EACI,yBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EAEA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AA3DhB;AA8DY;EACI,aAAA;EACA,mBAAA;EACA,aAAA;AA5DhB;AA+DY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA7DhB;AAgEY;EACI,WAAA;EACA,iBAAA;AA9DhB;AAiEY;EACI,aAAA;EACA,YAAA;EACA,YAAA;AA/DhB","sourcesContent":[".transfer-of-mgt {\n\n    &__head {\n\n        display: flex;\n\n        &__nav {\n            font-weight: 500;\n            color: #868686;\n        }\n\n        &__nav-span {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            color: #c1c1c1;\n            padding-left: 10px;\n            padding-right: 10px;\n        }\n\n        &__heading {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 28px;\n            line-height: 38px;\n            color: #333333;\n        }\n\n        &__top {\n            display: flex;\n        }\n\n        &__buttons {\n            flex: 1;\n            display: flex;\n            align-items: flex-end;\n            justify-content: space-between;\n            flex-direction: column;\n            margin-left: auto;\n\n            &__Area {\n                display: flex;\n\n                &__stat {\n                    padding-right: 10px;\n                }\n            }\n        }\n\n        &__description {\n            margin-top: 20px;\n\n            &__head {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 12px;\n                line-height: 18px;\n                color: #505054;\n            }\n\n            &__content {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 12px;\n                line-height: 18px;\n                color: #999999;\n            }\n        }\n\n        &__calendar {\n            width: 210px;\n        }\n    }\n\n    &__body {\n        display: flex;\n        margin-top: 30px;\n\n        &__col1 {\n            width: 35%;\n            height: calc(80vh);\n            margin-right: 5px;\n            background: #ffffff;\n            border-radius: 16px;\n            padding: 2%;\n        }\n\n        &__col2 {\n            width: 65%;\n            margin-left: 5px;\n            background: #ffffff;\n            border-radius: 16px;\n            padding: 2%;\n        }\n\n        &__head {\n            display: flex;\n            margin-bottom: 20px;\n\n            &__text {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 22px;\n                line-height: 32px;\n                color: #333333;\n            }\n\n            &__text-span {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 22px;\n                line-height: 32px;\n                color: #49ae9e;\n            }\n\n            &__button {\n                margin-left: auto;\n            }\n        }\n    }\n\n    &__emp-table {\n        max-height: 50vh;\n        text-align: center;\n        border-collapse: collapse;\n        width: 100%;\n        border-style: hidden;\n\n        tbody {\n            overflow-y: auto;\n        }\n\n        &__tr {\n            height: 50px;\n            flex-direction: row;\n            justify-content: center;\n            align-items: center;\n            padding: 8px 32px;\n            cursor: pointer;\n        }\n\n        &__td {\n            border: 1px solid #e9e9e9;\n            text-align: center;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 20px;\n            color: #505054;\n        }\n\n        .emp-table-item {\n            position: relative;\n            &:hover {\n                &:not(.selected)\n                    ::after {\n                    content: '급여보기';\n                    display: flex;\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    right: 0;\n                    bottom: 0;\n                    font-size: 12px;\n                    font-weight: 400;\n                    align-items: center;\n                    justify-content: center;\n                    background-color: #fafafa;\n                }\n            }\n        }\n\n        &__td-content {\n            border-bottom: 1px solid #e9e9e9;\n            border-top: 1px solid #868686;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 20px;\n            align-items: center;\n            color: #505054;\n        }\n\n        &__td-content-bold {\n            border-bottom: 1px solid #e9e9e9;\n            border-top: 1px solid #868686;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 20px;\n            align-items: center;\n            color: #505054;\n        }\n\n        &__td-content-lite {\n            position: relative;\n            border-bottom: 1px solid #e9e9e9;\n            border-top: 1px solid #868686;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 12px;\n            line-height: 18px;\n            align-items: center;\n            color: #505054;\n            &:hover {\n                &::after {\n                    content: '발송내역보기';\n                    display: flex;\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    right: 0;\n                    bottom: 0;\n                    align-items: center;\n                    justify-content: center;\n                    background-color: #fafafa;\n                }\n            }\n        }\n\n        &__td-content-num {\n            border-bottom: 1px solid #e9e9e9;\n            border-top: 1px solid #868686;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            align-items: center;\n            color: #505054;\n        }\n    }\n\n    &__payroll-stmnt {\n        &__description {\n            margin-top: 10px;\n            margin-bottom: 20px;\n        }\n\n        &__buttons {\n            display: flex;\n            flex-wrap: wrap;\n        }\n\n        &__button {\n            margin-right: 5px;\n            margin-bottom: 10px;\n        }\n\n        &__button-float {\n            margin-right: 5px;\n            margin-left: auto;\n        }\n\n        &__salary-type {\n            margin-top: 20px;\n            display: flex;\n            align-items: center;\n        }\n\n        &__toggle {\n            &__head {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 14px;\n                line-height: 20px;\n                color: #505054;\n                margin-left: 10px;\n            }\n\n            &__subhead {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 12px;\n                line-height: 18px;\n                color: #999999;\n                margin-left: 10px;\n            }\n\n            &__select {\n                margin-left: auto;\n            }\n\n            &__dropdown {\n                height: 40px;\n                background: #ffffff;\n                border: 1px solid #e9e9e9;\n                border-radius: 8px 8px 8px 8px;\n\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 14px;\n            }\n        }\n\n        &__table {\n            margin-top: 20px;\n            text-align: center;\n            border-collapse: collapse;\n            width: 100%;\n            border-radius: 6px;\n            border-style: hidden;\n            box-shadow: 0 0 0 1px #e9e9e9;\n\n            &__tr {\n                height: 50px;\n                flex-direction: row;\n                justify-content: center;\n                align-items: center;\n                padding: 8px 32px;\n                cursor: pointer;\n            }\n\n            &__td {\n                border: 1px solid #e9e9e9;\n                border-top: 1px solid #868686;\n                text-align: center;\n\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 14px;\n                line-height: 20px;\n                color: #505054;\n                background: #f9fafb;\n            }\n\n            &__td-content {\n                border: 1px solid #e9e9e9;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 20px;\n                color: #505054;\n            }\n\n            &__td-content-bold {\n                border: 1px solid #e9e9e9;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 14px;\n                line-height: 20px;\n                align-items: center;\n                color: #505054;\n            }\n\n            &__td-summary {\n                border: 1px solid #e9e9e9;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 14px;\n                line-height: 20px;\n                align-items: center;\n                color: #505054;\n                background: #f0f8f6;\n            }\n\n            &__td-summary-value {\n                border: 1px solid #e9e9e9;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 16px;\n                line-height: 22px;\n                text-align: right;\n                color: #075453;\n\n                text-align: end;\n                padding-right: 25px;\n                color: #505054;\n                background: #f0f8f6;\n            }\n\n            &__input-row {\n                display: flex;\n                align-items: center;\n                padding: 10px;\n            }\n\n            &__col-left {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 20px;\n                color: #868686;\n            }\n\n            &__col-right {\n                width: 90px;\n                margin-left: auto;\n            }\n\n            &__amount {\n                padding: 10px;\n                width: 200px;\n                margin: auto;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
